'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttrsWithTruncatedText = exports.handleDisclosureIconClick = exports.scrollToCard = exports.isRunningOnAppleDevice = exports.isFunction = exports.isRealTableWidthGreaterThanScrollContainer = exports.toUpperOrEmptyString = exports.doesFormattingRulesContain = exports.doesVisibleDataPointContains = exports.returnValueOrNull = exports.returnDashOrValue = exports.pathOrNull = exports.pathOrEmptyArray = exports.isObjectAndHasProp = exports.isApacRegion = exports.isEmeaRegion = exports.isNilOrEmpty = exports.isMobileBreakpoint = exports.isDataEmpty = exports.isTabOrMobileBreakpoint = exports.ifMobileBreakpoint = exports.isBreakpointThree = exports.isBreakpointFour = exports.conditionCheck = exports.allValuesNil = undefined;

var _ramda = require('ramda');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FunctionalUtility = {
  allValuesNil: function allValuesNil(arr) {
    return (0, _ramda.all)(_ramda.isNil)(arr);
  },
  conditionCheck: function conditionCheck(booleanCond, ifTrue, ifFalse) {
    return booleanCond ? ifTrue : ifFalse;
  },
  isBreakpointFour: function isBreakpointFour(breakpoint, ifTrue, ifFalse) {
    return breakpoint === 4 ? ifTrue : ifFalse;
  },
  isBreakpointThree: function isBreakpointThree(breakpoint, ifTrue, ifFalse) {
    return breakpoint === 3 ? ifTrue : ifFalse;
  },
  ifMobileBreakpoint: function ifMobileBreakpoint(breakpoint, ifCond, elseCond) {
    return (0, _ramda.ifElse)((0, _ramda.lt)(_ramda.__, 3), function () {
      return ifCond;
    }, function () {
      return elseCond;
    })(breakpoint);
  },
  isTabOrMobileBreakpoint: function isTabOrMobileBreakpoint(breakpoint, ifCond, elseCond) {
    return (0, _ramda.ifElse)((0, _ramda.lt)(_ramda.__, 4), function () {
      return ifCond;
    }, function () {
      return elseCond;
    })(breakpoint);
  },
  isDataEmpty: function isDataEmpty(prop) {
    if ((0, _ramda.isNil)(prop) || prop === 1) {
      return true;
    } else {
      return (0, _ramda.isEmpty)(prop);
    }
  },
  isMobileBreakpoint: function isMobileBreakpoint(breakpoint) {
    return (0, _ramda.lt)(breakpoint, 3);
  },
  isNilOrEmpty: function isNilOrEmpty(prop) {
    return (0, _ramda.or)((0, _ramda.isNil)(prop), (0, _ramda.isEmpty)(prop));
  },
  isEmeaRegion: function isEmeaRegion(country) {
    var emeaRegion = ['no', 'se', 'dk', 'fi', 'gb', 'ie', 'ch', 'de', 'at', 'be', 'lu', 'nl', 'fr', 'es', 'pt', 'it'];
    return !(0, _ramda.isNil)(country) && emeaRegion.indexOf(country.toLowerCase()) > -1;
  },
  isApacRegion: function isApacRegion(country) {
    var apacRegion = ['sg', 'au', 'jp', 'hk', 'tw'];
    return !(0, _ramda.isNil)(country) && apacRegion.indexOf(country.toLowerCase()) > -1;
  },
  isObjectAndHasProp: function isObjectAndHasProp(obj, prop) {
    return !isNilOrEmpty(obj) && (0, _ramda.has)(prop)(obj);
  },
  pathOrEmptyArray: function pathOrEmptyArray(path, object) {
    return (0, _ramda.pathOr)([], path, object);
  },
  pathOrNull: function pathOrNull(path, obj) {
    return (0, _ramda.pathOr)(null, path, obj);
  },
  returnDashOrValue: function returnDashOrValue(value) {
    return (0, _ramda.isNil)(value) ? "-" : value;
  },
  returnValueOrNull: function returnValueOrNull(prop, value) {
    return (0, _ramda.isNil)(prop) ? null : value;
  },
  doesVisibleDataPointContains: function doesVisibleDataPointContains(visibleDataPointName, data) {
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["fund", "visibleData", "visibleDataPoints"];

    return (0, _ramda.includes)(visibleDataPointName, pathOrEmptyArray(path, data));
  },
  doesFormattingRulesContain: function doesFormattingRulesContain(formattingRuleName, data) {
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["fund", "visibleData", "formattingRules"];

    return (0, _ramda.includes)(formattingRuleName, pathOrEmptyArray(path, data));
  },
  toUpperOrEmptyString: function toUpperOrEmptyString(str) {
    return (0, _ramda.toUpper)((0, _ramda.isNil)(str) ? "" : str);
  },
  isFunction: function isFunction(fn) {
    return typeof fn === "function";
  },
  isRealTableWidthGreaterThanScrollContainer: function isRealTableWidthGreaterThanScrollContainer(visibleTable, realTable) {
    return !(0, _ramda.isNil)(visibleTable) && !(0, _ramda.isNil)(realTable) && visibleTable.clientWidth < (0, _jquery2.default)(realTable).width();
  },
  isRunningOnAppleDevice: function isRunningOnAppleDevice(userAgent) {
    var isAppleDevice = /iPhone|iPad|iPod|Mac/.test(userAgent);
    return isAppleDevice;
  },
  scrollToCard: function scrollToCard(document, tabName, cardId, breakpoint) {
    var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 200;

    var tab = void 0;
    if (breakpoint > 3) {
      tab = document.querySelector("[data-tab-name='" + tabName + "']");
    } else {
      tab = document.querySelector("." + tabName + " .is-closed");
    }
    if (!(0, _ramda.isNil)(tab)) {
      tab.click();
    }
    if (!(0, _ramda.isNil)(cardId) && cardId != '') {
      setTimeout(function () {
        var node = document.getElementById(cardId);
        node.scrollIntoView();
      }, timeout);
    }
  },
  handleDisclosureIconClick: function handleDisclosureIconClick() {
    var compRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tooltipId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var tooltipText = arguments[3];
    var customTooltipConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};


    var disclosure = pathOrNull(['props', 'disclosure', tooltipId], compRef) || tooltipText;

    if (!disclosure || !event.target) {
      return;
    }

    var el = event.target;
    var elHeight = el.offsetHeight;
    var elWidth = el.parentNode.getBoundingClientRect().left;
    var elRect = el.getBoundingClientRect();
    var arrowHeight = 4;
    var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

    var toolTipWidth = void 0,
        toolTipContentWidth = void 0,
        closeTipPosition = void 0,
        toolTipContentScroll = 'hidden';
    if (disclosure[0].length > 380) {
      if (compRef.props.breakpoint > 3) {
        elWidth -= 150;
        toolTipWidth = 570;
        toolTipContentWidth = 530;
        closeTipPosition = 530;
      } else {
        toolTipContentScroll = 'auto';
      }
    }
    var elementHeight = docTop + arrowHeight + elHeight;
    var _customTooltipConfig$ = customTooltipConfig.topOffset,
        topOffset = _customTooltipConfig$ === undefined ? 0 : _customTooltipConfig$,
        _customTooltipConfig$2 = customTooltipConfig.leftOffset,
        leftOffset = _customTooltipConfig$2 === undefined ? 0 : _customTooltipConfig$2,
        width = customTooltipConfig.width,
        contentWidth = customTooltipConfig.contentWidth;

    var elOffset = {
      top: elRect.top + elementHeight + topOffset,
      left: elWidth + leftOffset,
      arrowPosition: elRect.left - elWidth - 3,
      toolTipWidth: width || toolTipWidth,
      toolTipContentWidth: contentWidth || toolTipContentWidth,
      closeTipPosition: closeTipPosition,
      toolTipContentScroll: toolTipContentScroll
    };

    if (!(0, _ramda.isNil)(compRef.props.tooltip)) {
      compRef.props.tooltip.openTooltip(elOffset, disclosure, null, true, event);
    }
  },
  setAriaAttrsWithTruncatedText: function setAriaAttrsWithTruncatedText(disclosureContainer, ariaTextContainer, predicate, containerForAriaLabel) {
    if (isNilOrEmpty(disclosureContainer) || isNilOrEmpty(ariaTextContainer)) {
      return;
    }
    if (predicate()) {
      return;
    }
    if (!disclosureContainer.textContent) {
      return;
    }
    var isShownOnPage = function isShownOnPage(ele) {
      return pathOrNull(['style', 'display'], ele) === 'none';
    };
    if (isShownOnPage(disclosureContainer)) {
      return;
    }
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (!context) {
      return;
    }
    var fontFamily = window.getComputedStyle(disclosureContainer).getPropertyValue('font-family');
    var fontSize = window.getComputedStyle(disclosureContainer).getPropertyValue('font-size');
    context.font = fontSize + ' ' + fontFamily;
    var ellipsisWidth = context.measureText('...').width;
    var truncatedText = disclosureContainer.textContent;

    var setAriaAttr = function setAriaAttr(truncatedTxt) {
      (containerForAriaLabel || disclosureContainer).setAttribute('aria-label', truncatedTxt);
      ariaTextContainer.innerText = truncatedTxt;
    };

    var measuredWidth = context.measureText(truncatedText).width;
    if (measuredWidth <= ellipsisWidth || disclosureContainer.clientWidth <= ellipsisWidth) {
      return;
    }

    if (measuredWidth <= disclosureContainer.clientWidth - ellipsisWidth) {
      setAriaAttr(truncatedText);
      return;
    }

    while (truncatedText && context.measureText(truncatedText).width > disclosureContainer.clientWidth - ellipsisWidth) {
      truncatedText = truncatedText.slice(0, -1);
    }

    setAriaAttr(truncatedText);
  }
};

exports.default = FunctionalUtility;
var allValuesNil = FunctionalUtility.allValuesNil,
    conditionCheck = FunctionalUtility.conditionCheck,
    isBreakpointFour = FunctionalUtility.isBreakpointFour,
    isBreakpointThree = FunctionalUtility.isBreakpointThree,
    ifMobileBreakpoint = FunctionalUtility.ifMobileBreakpoint,
    isTabOrMobileBreakpoint = FunctionalUtility.isTabOrMobileBreakpoint,
    isDataEmpty = FunctionalUtility.isDataEmpty,
    isMobileBreakpoint = FunctionalUtility.isMobileBreakpoint,
    isNilOrEmpty = FunctionalUtility.isNilOrEmpty,
    isEmeaRegion = FunctionalUtility.isEmeaRegion,
    isApacRegion = FunctionalUtility.isApacRegion,
    isObjectAndHasProp = FunctionalUtility.isObjectAndHasProp,
    pathOrEmptyArray = FunctionalUtility.pathOrEmptyArray,
    pathOrNull = FunctionalUtility.pathOrNull,
    returnDashOrValue = FunctionalUtility.returnDashOrValue,
    returnValueOrNull = FunctionalUtility.returnValueOrNull,
    doesVisibleDataPointContains = FunctionalUtility.doesVisibleDataPointContains,
    doesFormattingRulesContain = FunctionalUtility.doesFormattingRulesContain,
    toUpperOrEmptyString = FunctionalUtility.toUpperOrEmptyString,
    isRealTableWidthGreaterThanScrollContainer = FunctionalUtility.isRealTableWidthGreaterThanScrollContainer,
    isFunction = FunctionalUtility.isFunction,
    isRunningOnAppleDevice = FunctionalUtility.isRunningOnAppleDevice,
    scrollToCard = FunctionalUtility.scrollToCard,
    handleDisclosureIconClick = FunctionalUtility.handleDisclosureIconClick,
    setAriaAttrsWithTruncatedText = FunctionalUtility.setAriaAttrsWithTruncatedText;
exports.allValuesNil = allValuesNil;
exports.conditionCheck = conditionCheck;
exports.isBreakpointFour = isBreakpointFour;
exports.isBreakpointThree = isBreakpointThree;
exports.ifMobileBreakpoint = ifMobileBreakpoint;
exports.isTabOrMobileBreakpoint = isTabOrMobileBreakpoint;
exports.isDataEmpty = isDataEmpty;
exports.isMobileBreakpoint = isMobileBreakpoint;
exports.isNilOrEmpty = isNilOrEmpty;
exports.isEmeaRegion = isEmeaRegion;
exports.isApacRegion = isApacRegion;
exports.isObjectAndHasProp = isObjectAndHasProp;
exports.pathOrEmptyArray = pathOrEmptyArray;
exports.pathOrNull = pathOrNull;
exports.returnDashOrValue = returnDashOrValue;
exports.returnValueOrNull = returnValueOrNull;
exports.doesVisibleDataPointContains = doesVisibleDataPointContains;
exports.doesFormattingRulesContain = doesFormattingRulesContain;
exports.toUpperOrEmptyString = toUpperOrEmptyString;
exports.isRealTableWidthGreaterThanScrollContainer = isRealTableWidthGreaterThanScrollContainer;
exports.isFunction = isFunction;
exports.isRunningOnAppleDevice = isRunningOnAppleDevice;
exports.scrollToCard = scrollToCard;
exports.handleDisclosureIconClick = handleDisclosureIconClick;
exports.setAriaAttrsWithTruncatedText = setAriaAttrsWithTruncatedText;